import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-6 mb-4">
                  <div className="service-item">
                    <div className="service-image">
                      <img 
                        src={d.image} 
                        alt={d.name}
                        className="img-fluid" 
                        style={{ 
                          maxHeight: "300px", 
                          objectFit: "cover", 
                          width: "100%",
                          pointerEvents: "none" // Makes the image non-interactable
                        }}
                      />
                    </div>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <ul className="service-details text-left">
                        {d.details.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};